module.exports = {
  qqgdscpjypt:
    "China International Seafood Exchange (Shenzhen International Tuna Trading Co., LTD.)",
  qqgdscpjypt1: "China International Seafood Exchange",
  qqgdscpjypt2: "(Shenzhen International Tuna Trading Co., Ltd.)",
  zczh: "Create account",
  yzmdl: "Verification Code",
  zhmmdl: "Password",
  sjh: "Mobile Phone NO.",
  yzm: "Verification Code",
  yhylsjh: "Bank reserved mobile No.",
  qsrsjh: "Please enter your mobile phone NO.",
  qsryzm: "Please enter the verification code. ",
  hqyzm: "Get Verification Code",
  qsrmm: "Please enter the password",
  dl: "Login",
  dlsb: "Login failure",
  dlgqqcxdl: "Login time out , please login again...",
  zc: "Register",
  zcsb: "Register failure",
  yzmbnwk: "The verification code cannot be empty",
  hqyzmsb: "Failed to obtain the verification code",
  yzmfscg: "The verification code is sent successfully",
  sjhbnwk: "The mobile No. cannot be empty",
  sjhgscw: "The format of the mobile No. is incorrect",
  mmbnwk: "The password cannot be empty",
  mmtips:
    "The password must be a combination of 8 to 16 letters, numbers, and characters (cannot be pure numbers).",
  bottomcopyright1:
    "2023 SHENZHEN INTERNATIONAL TUNA TRADING CO.,LTD. ICP certificate : Guangdong ICP NO.2023112184-1",
  bottomcopyright2: "Beijing public security bureau record No. 11010802026156",
  ztsc: "Topic",
  hello: "Hello",
  qrz: "To approve",
  rzhjkckjyxqy:
    "After authentication, you can view the page of transaction details ",
  qkh: "To create account",
  khhjkzptwcjy:
    "After opening an account, you can complete the transaction on the platform",
  khsbxycxkh: "Account opening failed. You need to open an account again",
  qyz: "To verify",
  dzhyz: "Pending account verification",
  rzqyykhqlxkf:
    "Certified the enterprise has opened an account, please contact customer service",
  zljyz: "The data is under review",
  shz: "Reviewing",
  clz: "Dealing",
  dzqyz: "Electronic signing",
  jnrzbzj: "Arragned the deposit",
  jnrzbzjhkschy:
    "After paying the deposit， please upload the cargo information",
  wyhyxzzycjj: "I have the cargo and I want to organize a auction",
  wyhyxzjmc: "I have the cargo and I want to sell out directly",
  yrz: "Certified",
  hyzx: "Aquatic products information",
  gd: "More",
  qb: "All",
  zq: "Special Zone",
  kssj: "The opening time",
  ksz: "Opening",
  xsz: "Closed",
  xqyzxqldsj: "Monday to Saturday (except for holidays)",
  morning: "9:00 am-11:30 am",
  zwsj: "9:00-16:30",
  jjmc: "Sell by bidding",
  jjmr: "Buy by bidding",
  wyddxzzycjj: "I have the order and I want to organize a auction",
  gpmc: "Sell by listing",
  gpmr: "Buy by listing",
  wyddxsgyphy: "I have the orders and I want to purchase the cargo",
  bhtjy: "ncluding 10 transactions",
  bh: "Including ",
  jyy: " transactions",

  jjkp: "Coming Soon",
  jjks: "Coming soon",
  bmz: "Registering",
  jxz: "In Progress",
  yjs: "Ended",
  lp: "Bought-In",
  wbmd: "My Registration",
  zxsc: "Latest Upload",
  kpsj: "Bidding Time",
  w: "I",
  wd: "My",
  jg: "Price",
  qpj: "Listing price",
  dqj: "Price",
  cjj: "Deal price",
  yuan: "Yuan",
  zwxgxx: "No relevant content yet！",

  ryd: "persons read already",
  qxdzcg: "Unliking succeeded",

  bm: "Sign up",
  xzkhjl: "Adding the new cargo record",
  jbxx: "Basic information",
  hymc: "Commodity name",
  qsrhymc: "Please enter commodity name",
  dw: "Unit",
  djtxdw: "Click and fill out the unit",
  tiao: "piece",
  dun: "ton",
  zl: "weight",
  hydz: "Commodity address",
  hyzp: "Commodity photos",
  scp: "Uploading photos",
  zdjz: "（Up to nine photos）",
  bcqtxx: "Additional information",
  bcbtj: "Save and submit",
  cjfdxdydqjg: "Offer must be more than the current price",
  fscgddmfqr: "Send successfully, waiting for the seller's confirmation",
  cjcg: "Offer successfully",
  cjsb: "Offer  unsuccessfully",

  sy: "Homepage",
  rz: "Authentication",
  grrz: "Personal authentication",
  gsrz: "Company’s authentication",
  sczj: "Uploading files",
  xm: "Name",
  qsrxmxysfzbcyz: "Please enter your name same as ID",
  ztlx: "Company type",
  djxzlx: "Click and select the type",
  jysx: "Business attribute",
  djxzsx: "Click and select the attribute",
  jydz: "Company address",
  djxzdz: "Click and select the address",
  xxdz: "Detailed address",
  qsrxxdz: "Please enter the detailed address",
  jypx: "Major products",

  djxzpx: "Click and select the products",
  gsmc: "Company name",
  qsrgsmcxyyyzzyz: "Please enter the company name same as business license",
  qsrgsmc: "Please enter the company name",
  lxr: "Contact person",
  qsrlxr: "Please enter the contact person",
  qscsfz: "Please upload your photo ID ",
  qscsfzwssfxx: "Please upload your photo ID and complete the ID information",
  qpsbscndyyzz: "Please upload your photo business license",
  djscsfzzm: "Click and upload the front of ID ",
  djscsfzbm: "Click and upload the back of ID ",
  djscyyzz: "Click and upload your photo business license",
  tj: "Submit",
  tjrz: "Submit for certification",
  thcg: "Submit successfully",
  tjsb: "Submit unsuccessfully",
  yqm: "Invitation code ",
  yqmxt: "Invitation Code （optional）",
  qtxyqm: "Please fill out invitation code ",
  sryqmrwkbt:
    "Please enter invitation code ， if none is available, leave it blank",
  qd: "Confirm",
  qx: "Cancel",
  sctpyc: "Upload photos abnormally",
  sfzxmysrxmbyzqcxtr:
    "The name of ID is different from the entered name. Please fill in again",
  yyzzmcysrmcbtzqcxtx:
    "The name of company is different from the business licence. Please fill in again",
  tpsbycqcxsc: "Upload photos abnormally，please check the photos",
  rzsb: "Authenticate unsuccessfully",
  rzyc: "Authenticate abnormally",
  qsryqm: "Please enter the invitation code",

  grzx: "Personal Center",
  zhye: "Account balance",
  wdye: "My account balance",
  ljczlc: "To know the recharge process",
  tx: "Withdraw",
  bccg: "Save successfully",
  bcsb: "Save unsuccessfully",
  bcyhcw: "Save user error",
  txtp: "Profile photo",
  bdsjh: "Bind mobile No.",
  hb: "Change binding",
  dlmm: "Login password",
  qsz: "Install",
  xgmm: "Change password",
  szmm: "Password setting",
  qr: "Confirm",
  djscndtx: "Click and upload your profile photo",
  hbsjh: "Change binding mobile No.",
  qsrhbsjh: "Please enter the changing mobile No.",
  dqsjh: "Current mobile No.",
  ghcg: "Changing successfully",
  xgcg: "Revising successfully",
  szcg: "Setting up successfully",
  uploatips: "The size of the uploaded file cannot exceed 5MB",
  success: "Success",
  fail: "Failure",

  zhmx: "Account details",
  mj: "Seller",
  maij: "Buyer",
  dj: "Blocked",
  djmx: "Blocked account details",
  yjcdj: "Releasing the blocked account",
  zrtxje: "Transfer the withdrawal details",
  pfmx: "Compensation details ",

  rzbzj: "Entry deposit",
  bzjtips:
    "If the seller's client initiates the transaction, the deposit shall not be less than 100,000 yuan.",
  bzjtips1:
    "During the trial operation stage, this regulation is not implemented temporarily",
  zcdz: "Transferred out",
  zrdz: "Transferred in",

  qrcj: "Bid",
  hpmc: "Description of goods",
  zxjg: "The updatest price",
  ykj: "Buy it now price",
  jpcj: "Place bid ",
  cjf: "Bidder",
  dunshu: "Tonnage",
  zdbmds: "Minimum registered tonnage",
  grds: "Tons purchased",
  cjje: "Bid amount",
  qsrndgrds: "Please enter your purchased quantity",
  qsrndcjje: "Please enter your bid amount",

  wddd: "My order",
  hyd: "Origin of goods",
  shd: "Place of receipt",
  djkckmfhy: "Click to view the seller's source of goods ",
  hyzj: "The total amount of goods",
  djtips: "Deposit (freezing performance bond to offset payment for goods",
  fwf: "Service charge",
  wk: "The balance payment",
  ddbh: "Order number",
  copy: "Copy",
  cjsj: "Create date",
  mffk: "Buyer payment",
  ccbg: "The report of goods",
  zskf: "Exclusive customer servic",
  hckf: "Huacai customer servic",
  dfpkf: "To Be Assigned QC",
  lxpk: "Contact QC",
  qfk: "To pay",

  txmfhy: "Fill out the seller‘s goods information",
  ckmfhy: "Review the seller‘s goods information",
  hyxx: "Source of goods information",
  ddxx: "Order information",
  ksrbcne: "Input supplementary content ..",
  bt: "Required",
  xt: "Optional",
  fsgmf: "Sent to the buyer",

  sztx: "Setting up reminders",
  sztxcg: "Setting up reminders successfully",
  qxtxcg: "Cancelling reminders successfully",
  szsb: "Setting up reminders unsuccessfully",
  qxbmcg: "Cancelling sign-in successfully",
  ysz: "Set up",
  jjs: "From end",
  jks: "Countdown to start",
  sc: "Duration",
  kdjckkhjl: "Click to view the record of goods",
  bm10sr: "** persons signed up",
  wg10ren: "Watch 10 times",
  jybh: "Deal number",
  jplx: "Bidding type",
  jjfd: "Price Increase Range",
  jjfdjj: "Reduction scope",
  jpsj: "Bidding time",
  jpsc: "Bidding duration ",
  fz: "Minute",
  yszq: "Delay period",
  jylx: "Deal type",
  scsj: "The time of uploading",
  lxdh: "Hotline",
  ppxq: "Bidding Details",
  pkbb: "Quality Control Report",
  cjjl: "Records of bid",
  xqms: "Description of demand",
  hyms: "Description of Goods",
  jjr: "Bidder",
  sj: "Time",
  ckgd: "View More",
  zwcjjl: "No bidding record",
  smewmdsj: "Scan a QR Code",
  dqrp: "Current hot auction",
  yhwrzqdgezxrz:
    "User not authenticated, please go to the personal center for authentication ",

  ckkhxx: "View the goods information",
  lsjl: "The history record",
  bmcg: "Signed up successfully",
  dmfqr: "To be confirmed by the buyer",
  mfjj: "The buyer refused",
  mfcswcl: "The buyer didn’t deal with it due to timeout",
  bj: "Edit",
  delete: "Delete",
  qrxgfsgmf: "Confirm modification and send to the buyer",
  qrscgkhxx: "Confirm deleting the viewed goods informaiton？",
  sccg: "Delet successfully",
  ldfs: "Freezing method ",
  jjsz: "Bidding settings ",
  jjrq: "Bidding date",
  djxzjjrq: "Click to select the bidding date",
  jjsj: "Bidding Time",
  djxzjjsj: "Click to select the bidding time",
  jjsc: "Bidding Duration",
  djxxjjsc: "Click to select the bidding duration",
  srsz: "Put into the number",
  gpsz: "Listed settings",
  jgsz: "Delivery settings",
  yf: "Freight",
  djlybzj: "Freezing performance bond ",
  tjhddsh: "Submit and wait for review",

  bmlb: "Sign-up list",
  dqr: "Pending approval",
  yjj: "Refused",
  yqr: "Confirmed",
  bmbh: "Sign-up number",
  bmsj: "Sign-up time",
  sfjjbm: "Do you refuse to sign up?",

  syrzbzjy: "Remaining deposit (RMB)",
  rzbzjtips1:
    "If the seller initiates a transaction, the deposit must not be less than 100000 yuan",
  zrje: "Transfer-in amount",
  qsrzrje: "Enter the transfer-in amount",
  qbzr: "Transfer-in all",
  yczr: "Transfer-in from here",
  zrcg: "Transfer-in successfully",
  zrsb: "Transfer-in unsuccessfully",

  zcje: "Transfer out amount",
  qsrzcje: "Enter transfer out amount",
  qbzc: "Transfer out all",
  zcz: "Transfer out to",
  zccg1: "Transfer out successfully",
  zcsb1: "Transfer out  unsuccessfully",

  ktzfzh: "Opening an account ",
  grkh: "Individual account",
  qykh: "Company account",
  gtgshkh: "Opening an Individual Business Account",
  khsb: "Opening an account unsuccessfully",
  wdyhk: "My bank card",
  yjhb: "Replacing bank card",
  bdyhk: "Binding the bank card",
  zhlx: "Account type",
  qdjxz: "Please click to select",
  dgzh: "To company",
  dszh: "To private person",
  ckr: "Cardholder",
  qsrckrxm: "Please enter the name of cardholder",
  qsrxm: "Please enter the name",
  yhkh: "Bank card number",
  qsrkh: "Please enter bank card number",
  khh: "Opening bank",
  qsrkhh: "Please enter opening bank",
  zcyh: "Cooperative bank",

  wfbd: "My issue",
  wdjy: "My deal",
  wgzd: "My concern",
  qtgn: "Other Function",

  yx: "Email",
  dz: "Address",
  kfzsewm: "Customer service's QR Code",
  qtxzgcyhdwzs:
    "Please fill in the amount of transfer from Zhongguancun Bank to the corporate account",
  skjey: "Account receivable(Yuan)",
  ytjqnxddsh: "Submitted, please wait patiently ",

  yey: "Balance (yuan)",
  txje: "Withdraw amount",
  qsrtxje: "Enter withdraw amount",
  qbtx: "Withdraw all",
  dzyhk: "Incoming bank card",

  jjcj: "Bid",
  ydzdcj: "The bottom price",
  zklyx: "Think again",
  jjcg: "Sold",
  jyts: "Deal notice",
  qrybdyhk: "Confirm that the bank card has been bound ",
  syysyhkxrxzhhk:
    "Use the above bank cards to remit money to the following account",
  zhm: "Account name",
  zhzh: "Account number",
  zhc: "Huacai  Zhang",
  bjyhzgczh: "Beijing Zhongguancun Bank Corporation Limited",
  xzf: "Need to pay",
  wkyf: "Need to pay balance",
  xzzffs: "Select the payment method",
  wdzh: "My account",
  qrzf: "Confirm to pay",
  zhyebzljzr: "Account balance is insufficient, please transfer",
  zfcg: "Pay successfully",
  bmxz: "Instructions for registration",
  dqbdlybzj: "The current bid bond",
  ndzhye: "Your account balance",
  bmjjjbstyxydjbzj:
    "Signing up for bidding means agreeing to freeze the corresponding bid bond ",
  rwhpjth:
    "If the bid is unsuccessful, the frozen bid bond will be released automatically",
  rcgzcdhk:
    "If the auction is successful, the frozen bid bond will be used as a deposit against the payment when you pay the final payment",
  rcgpxjkc:
    " If you fail to perform the contract after successful bidding, the frozen deposit will be deducted",
  zhyebzwfbm: "The account balance is not enough to sign up",
  qzr: "Roll-in",
  qrbm: "Confirm of signing up",

  zd: "Roll-out",
  ye: "Page",

  scxgzj: "Upload the related documents",
  qscyyzz: "Please upload your business license",
  yyqx: "Term of operation",
  qsryyqx: "Please enter term of operation",
  zcdz1: "Registered address",
  qsrzcdz: "Please enter registered address",
  tyshxydm: "Uniform social credit code",
  qsrtyshxydm: "Please enter uniform social credit code",
  qsczzjgdmz: "Upload Certificate of Organization Code",
  djsczzjgdmz: "Click to upload Certificate of Organization Code",
  zzjgdm: "Certificate of Organization Code",
  qsrzzjgdm: "Please enter Certificate of Organization Code",
  zzjgdmzqx: "Certificate of Organization Code valid term",
  qsrzzjgdmzqx: "Please enter Certificate of Organization Code valid term",
  qscswdjz: "Upload Tax registration certificate  ",
  djscswdjz: "Click Tax registration certificate  ",
  swdjzdm: "Tax registration certificate code",
  qscfrsfz: "Pleas upload legal person‘s ID",
  sfzh: "ID",
  qsrsfzh: "Please enter ID",
  sfzyxq: "ID valid date",
  qsryxq: "Please enter the valid date",
  qsclxrsfz: "Please upload the contact person's ID",
  lxrxm: "Contact name",
  lxrsfzh: "Contact ID",
  lxrsjh: "Contact cell phone number",
  qsrlxrsjh: "Please enter the contact person‘s cell phone",
  lxryx: "Email address",
  qsrlxryx: "Please enter the contact email",
  zhmc: "Account name",
  qsrzhmc: "Please enter account ",

  wdfb: "My release",
  tcdl: "Log Out",
  smjrxcx: "Scan into Mini apps",
  czgjfbkj: "The operation is more convenient and fast",
  ss: "Search",
  tgsh: "Pass the audit",
  js: "End",
  bohui: "Reject",
  scdd: "Generate",
  xgjg: "Change the price",
  qdgj: "Fixed price change",
  xjhyyy: "Take off the shelf",
  bmhy: "Registered source of goods",
  ckdd: "View the order",
  pkdh: "Quality control telephone",
  bmdjj: "Registered bidding",
  bmdgp: "Registered listing",
  dzdwz: "Liked articles",
  mairu: "Buy",
  maichu: "Sell",
  grxx: "Personal information",
  grsy: "Personal Home Page",
  quhao: "Area code",
  dfk: "Pending payment",
  djg: "Pending delivery",
  ywc: "Completed",
  qt: "Other",
  dsh: "Pending Review",
  zsz: "On Display",
  nhqdl: "Hello, please log in",
  mfzc: "Free registration",

  jyzx: "Exchange",
  qgsj: "National",
  qqsj: "Global",
  cczx: "Service",
  gzzx: "Rules",
  lxwm: "Contact us",
  hyzx11: "News",
  sjzx: "Price",
  grzxxx: "Personal",

  szgjjqyjyzx: "Shenzhen International Tuna Trading Co., LTD.",
  qqgdscpjyzx: "China International Seafood Exchange",
  djjrjyzx: "Click to enter the trading platform",
  gjst: "Co-construction ecology",
  hzgyy: "Win-win cooperation",
  gongsijieshao: "Company introduction",
  pingtaijieshao: "Platform introduction",
  dazaoqqzddyyjypt:
    "Build a global online trading center for high-end aquatic products",
  gsjstips111:
    "Initiated by China Water Group Cosco Co., LTD., a subsidiary of China Agricultural Development Group, Huacai Technology (Beijing) Co., Ltd. provides technical and professional support.",
  lliaojiexiangq: "Learn More",
  guankanship: "Watch video",
  xianshangjiaxianxia: "Online + Offline",
  gsjstips222:
    "The company is committed to building a global online trading center for high-end aquatic products, driven by the twin engines of ‘online’ + ‘offline’, connecting remote high-end aquatic products with live auction transactions through a remote digital trading center.",
  sjzgrdbzsrjg: "Upgrade the protein intake structure of the Chinese people",
  gsjstips333:
    "Guided by the concept of big food, guided by the concept of ecological co-construction and win-win cooperation, it promotes the industrial digitization process of high-end aquatic products by means of science and technology, improves the trading and circulation efficiency of global high-end aquatic products, upgrades the protein intake structure of Chinese people, and reconstructs the new digitization ecology of global high-end aquatic products.",
  gaoduanshuichanpzonghefuwupingtai:
    "Comprehensive industrial service platform for high-end aquatic products",
  gsjstips444:
    "Approved by Shenzhen Municipal Government, it is jointly initiated by China Agricultural Development Group and Shenzhen Port Group, with technical support from Beijing Huacai. As Shenzhen national oceangoing fishery base pilot project put into operation. Officially launched on May 12, 2023, the center is a comprehensive industrial service center for high-end aquatic products, focusing on spot trading of high-end aquatic products, integrating standard formulation, new varieties research and development, market information services, technical services, financial services and logistics services.",
  pingtai1: "Covering the world's major tuna trading centers",
  pingtai2:
    "With Shenzhen as the hub, the center links Dalian, Yantai, Zhoushan, Tokyo, Kaohsiung, Bangkok and other important global tuna distribution centers, and sets up delivery warehouse to achieve global delivery; In addition to tuna, the center also covers high-end aquatic products such as codfish, salmon, king crab and lobster.",
  pingtai3:
    "Transaction internationalization, standardization, information and digitization",
  pingtai4:
    "The center undertakes the important task of promoting the innovation and upgrading of the global high-end aquatic product industry, and realizing the internationalization, standardization, informatization and digitalization of aquatic product trading; The Center will gradually build itself into an international high-end aquatic products trading, settlement and pricing center in the Asia-Pacific region by utilizing its strong market operation capability, resource integration capability and preferential policy supporting resources.",
  adv1: "Our Advantages",
  adv2: "Cloud trading, global delivery, exclusive resources, Shenzhen prices",
  adv3: "High-end",
  adv4: "High efficiency",
  adv5: "High quality",
  adv7: "High quality",
  adv6: "To build a high-end aquatic products trading center, settlement center and pricing center in the Asia-Pacific region",
  cloud1: "Cloud trading",
  cloud2: "Global Delivery",
  cloud3: "Exclusive Resources",
  cloud4: "Shenzhen Price",
  cloud5: "Full Traceability",
  cloud6: "AI inspection",
  cloud7: "Data Engine",
  cloudIntro1:
    "Cloud trading---One-click trading around the world, unlimited access to global transactions.",
  cloudIntro2:
    "Global delivery--- Local delivery in major global distribution centers reduces logistics costs",
  cloudIntro3:
    "Exclusive resources -- Gather the world's high-end aquatic products, Designated sales channels of North Atlantic Bluefin tuna in China.",
  cloudIntro4:
    "Shenzhen Price---Release the global tuna distribution center city trading prices to help the Chinese market establish a pricing center position",
  cloudIntro5:
    "Full traceability - One fish one code to ensure that the source information is true； the whole source can be traced in order to achieve 100 percent food safety",
  cloudIntro6:
    "AI image recognition strengthens quality control ability, reduces traditional fish inspection error through unified detection standards, and improves multi-scene application efficiency.",
  cloudIntro7:
    "Data engine---Enhance decision-making accuracy through big data mining.",
  gsdzzzzz:
    "Address: 15 / F, Building B, Haina Baichuan Headquarters Building, No. 6, Baoxing Road, Xinan Street, Seaside community, Baoan District, Shenzhen",
  xcxxxx: "Mini Apps",
  fwhhhh: "Official Accounts",
  wzdhhh: "Website Navigation",
  pzzx: "Delivery Center",
  login1: "Creating ecological cooperation for mutual benefit",
  login9:
    "Promoting the digitization process of high-end aquatic products through technology",
  login11: "Log in now",
  person1: "Personal home page",
  person2: "Personal information",
  person7: "Account opening procedure",
  qkk: "Go",
  wfbdjy: "My Issued Deals",
  rxtel: "Hot line",
  kfrxxx: "Hot line",
  gzsjjj: "Working time",
  jqy: "Tuna",
  qtpl: "Other categories",
  cjjjj: "Deal",
  qpppp: "Start shooting",
  plll: "Product Name",
  pxxx: "Goods Description",
  jqyfl: "Classification of tuna",
  zzjx: "Be in progress",
  jssj: "End time",
  ysztx: "Set reminder",
  dpsjgzg: "Large screen",
  cdxx: "Origin",
  ggzbjdx: "Size proportion and specifications",
  hours: "Hour",
  minus: "Minutes",
  second: "Seconds",
  wxsys: "Scan wechat",
  service1: "What services do we have",
  service2:
    "Provide the customers with the comprehensive professional services that energizes to the persistent increasing of the business.",
  service3: "Financial Services",
  service4:
    "Aim to provide comprehensive financial support for clinets and customers，help them solve their capital turnover difficulties，improve the deal efficiency and lower the deal costs .",
  service5: "Comprehensive",
  service6: "Logistics Services",
  service7:
    "Aim to provide efficient and convenient logistics support for clinets and customers，help them close a deal well and logistics distribution .",
  service8: "Efficiency",
  service9: "Data Services",
  service10:
    "Aim to provide comprehensive，timely and  accurate support for clinets and customers，help them  know the market trends, and make the wiser decisions.",
  service11: "Profession ",
  service12: "To know all about us",
  service13:
    "Including financing services, settlement services and risk management services, the center aims to provide comprehensive financial support for upstream and downstream customers, help them solve the problem of capital turnover, improve transaction efficiency and reduce transaction costs. The center also plans to further expand financial services, including the establishment of a financial product innovation center, to provide more comprehensive and professional financial services for upstream and downstream customers.",
  service14:
    "Including warehousing services, distribution services, customs clearance services, insurance services, aiming to provide efficient and convenient logistics support for upstream and downstream customers, to help them better complete transactions and logistics distribution. The center also plans to further expand logistics services, including the establishment of a logistics information platform and the development of SAAS tools for logistics management, to provide more comprehensive and efficient logistics support for upstream and downstream customers.",
  service15:
    "Including real-time market data, trading data analysis, market information release, and data customization services, it aims to provide upstream and downstream customers with comprehensive, timely and accurate trading data and market information to help them understand market dynamics and trends and make smarter trading decisions. The center also plans to further expand its data services, including the establishment of data centers and the development of data analysis software, so as to provide more comprehensive and professional data support for upstream and downstream customers.",
  slx: "Quantity (box)",
  cdmc: "Name of origin",
  rknf: "Year of warehousing",
  rkyf: "Warehousing month",
  ggzbjdxplace:
    "Please write down the proportion and size of the specifications contained in the goods source, for example, the proportion of 100-150 specifications is 25%, which is too large; Specification 200-3000 accounts for 75%, normal size",
  rules1:
    "Summary of Rules of the Seafood Exchange (Shenzhen International Tuna Trading Co., LTD.) (Trial)",
  rules2: "Chapter I General Provisions",
  rules3: "Article 1",
  rules4:
    "In order to standardize the online trading rules of the Global High-End Aquatic Products Trading Platform (i.e., Shenzhen International Tuna Trading Co., Ltd.) (hereinafter referred to as the trading platform), maintain market order, and protect the legitimate rights and interests of traders, this regulation is formulated in reference to relevant laws and regulations such as the Civil Code of the People's Republic of China and the Service Specifications for Third-Party E-commerce Trading Centers.",
  rules5: "Article 2",
  rules6:
    "These Rules apply to the trading activities on the Seafood Exchange (Shenzhen International Tuna Trading Co., LTD.). All staff, members, market makers, settlement warehouses and related cooperative institutions of the Seafood Exchange must comply with these Rules.",
  rules7: "Chapter II Transactions",
  rules8: "Article 3 Opening hours",
  rules9:
    "1.Monday to Friday（Except holidays）: 9:30 am -11:30 PM 13:30 PM -16:30 PM;",
  rules10: "2.The market is closed on Saturdays & Sundays and public holidays",
  rules11: "Article 4 Charging Standard",
  rules12:
    "The buyer and seller shall pay different fees according to different transaction methods and categories. For details, please refer to the Platform Fee Standard.",
  rules13: "role",
  rules14: "Buyer.",
  rules15: "Seller.",
  rules16: "Initiating transaction mode",
  rules17: "Trading rules",
  rules18:
    "The buyer uploads the purchase demand, sets the starting price, and the seller bids according to the buyer's demand. The one with the lowest price wins.",
  rules19:
    "The buyer uploads the purchase demand, sets the price and quantity threshold, and the seller sells according to the buyer's demand.",
  rules20:
    "The seller uploads the goods for sale, sets the starting price, and the buyer bids according to the seller's demand. The highest price wins.",
  rules201:
    "The seller uploads the details of the goods for sale, sets the starting price, and the buyer bids according to the seller's demand. The highest price wins.",
  rules21:
    "The seller uploads the goods details, sets the price, quantity and other thresholds, and the buyer buys according to the seller's goods.",
  rules22: "Central rate",
  rules23: "(interim)",
  rules24:
    "Buyers participate in the trading will be charged a service fee of 3‰ of the total price of goods.",
  rules25:
    "Sellers participate in the trading will be charged a service fee of 1‰ of the total price of goods, while the maximum service fee is 500,000CNY.",
  rules26: "Transaction deposit",
  rules27:
    "Transaction deposit: The buyer shall first pay 20% of the total price of goods as the deposit, which will be offset against the payment after trading.",
  rules28:
    "Sellers shall deposit 100,000CNY in the Trading Platform account in order to sell the products on the Trading Platform.",
  rules29: "Payment and delivery time",
  rules30: "The balance shall be paid within 24 hours after placing the order.",
  rules31: " (If overdue, please contact the service center)",
  rules32:
    "Delivery will be arranged according to the agreed time of both sides after full payment from the buyer.",
  rules33: "Article 5",
  rules34:
    "The quote currency is CNY, and the quote unit is: specified according to the requirements of the category.",
  rules35: "Article 6",
  rules36:
    "All users shall pay the full transaction deposit before they can participate in selling/buying or registration/bidding as buyers and sellers in the Seafood Exchange.",
  rules37: "Article 7 Transaction deposit",
  rules38:
    "Buyers and sellers shall pay the corresponding trading deposit according to the requirements of the Trading Platform. After the transaction succeeds, the deposit will offset the payment. ",
  rules39: "Article 8 Refund of transaction deposit",
  rules40:
    "In accordance with the refund conditions, the deposit will be returned to the original bank account within 2 working days.",
  rules41: "Article 9 Deposit deduction",
  rules42:
    "If the seller is involved in any of the following situations when the successful bidding of the goods supply is published by the seller, the seller will be penalized with a deposit equal to the transaction amount. If the deposit is insufficient, the full amount of the deposit in the account will be deducted:",
  rules43:
    "1.Delivery source quality is seriously inconsistent with description;",
  rules44:
    "2.The delivery of goods is completed not in accordance with the stipulated time and procedures;",
  rules45:
    "3.Fail to perform the contract obligation according to the published bidding price.",
  rules46:
    "4.The Center will deduct the deposit equal to the transaction amount. If the deposit is insufficient, the full amount paid will be deducted.",
  rules47:
    "If the buyer is involved in any of the following circumstances after winning the auction, the buyer will be penalized with a deposit equal to the transaction amount. If the deposit is insufficient, the full amount paid will be deducted:",
  rules48:
    "1.The delivery of goods is not completed in accordance with the stipulated time and procedures;",
  rules49:
    "2.Fail to perform the contract obligation according to the published bidding price.",
  rules50:
    "3.The Center will deduct the margin equal to the transaction amount, if the margin is insufficient, the margin will be deducted",
  rules51: "Article 10 The Flow Direction of Deposit Deduction",
  rules52:
    "1.If the bidding is successful, but the buyer fails to complete the payment within 1 natural day after the bidding ends (during transaction payment period), and the transaction does not support negotiation to resume the transaction, the deposit paid by the buyer will be forfeited after the end of the payment period of the transaction and paid to the seller as compensation.",
  rules53:
    "2.If the bidding is successful, but the buyer fails to complete the payment within 2 natural days after the bidding ends (during transaction payment period), and the order does not apply for recovery within the negotiated transaction recovery period, the deposit paid by the buyer will be forfeited and paid to the seller after the resumption of the transaction period.",
  rules54:
    "3.If the bidding is successful, but the buyer fails to complete the payment in time within 1 natural day after the bidding ends (during transaction payment period), and the order  applies for recovery within the negotiated transaction recovery period but is not processed by the seller or is refused to resume the transaction, the deposit paid by the buyer will be forfeited and paid to the seller after being refused to resume the transaction.",
  rules55:
    "4.If the seller who has paid the deposit fails to deliver the lot to the buyer as agreed after the transaction, the deposit paid by the seller will be forfeited and paid to the buyer as compensation.",
  rules56: "Article 11 The deduction of service fee in the forfeited deposit",
  rules57:
    "1.If the deposit paid by the buyer is forfeited to the seller due to the buyer's breach or violation of contract, the service fee will not be refunded and the buyer has the right to deduct the deposit directly at the time of forfeiting.",
  rules58:
    "2.If the deposit paid by the seller is forfeited to the buyer due to the seller's breach or violation of contract, the corresponding deposit will be deducted based on the actual situation.",
  rules59:
    "3.Special circumstances: If you have any objection to the return or deduction of the deposit, you can appeal through the Seafood Exchange. The Seafood Exchange, as an intermediary, will coordinate fairly with the buyer and seller to decide whether to return the deposit or make the corresponding deduction, but the Seafood Exchange will not bear any liability.",
  rules60: "Article 12",
  rules61:
    "The uploaded information shall include but not be limited to: type, category item specification, tonnage, warehousing time, fishing method, freezing method, fishing area, selling method, source party, photos of source, description of source, etc.",
  rules62:
    "Description of the source of the products: Name, weight size, grade, wild/cultured, whole round/cut, specifications, freezing method, packing, weighing deduction of fixed weight and other supplementary information.",
  rules621:
    "Order description: category, price, place of shipment, invoice information, etc.",
  rules63: "Article 13 Transaction methods and suggestions on selection",
  rules64:
    "1.Users can choose to log in the Seafood Exchange bidding and listing.",
  rules65:
    "2.Delay: If there is any bid within 1 minute of the countdown before the end of bidding, the bid will automatically delay 3 minutes on the basis of the bid time, and so on, until no one continues to bid within 1 minute before the end of the countdown, the bidding will end.",
  rules66: "Matters needing attention",
  rules67:
    "Pay attention to set the purchase quantity threshold to prevent malicious bidding. E.g. A ton of goods compete at a low price.",
  rules68: "Understand market price trends to ensure smooth trading.",
  rules69: "Clear source details to ensure the quality of the transaction.",
  rules70: "Clear source details to ensure the quality of the transaction.",
  rules71: "Selection suggestion",
  rules72:
    "The price of the goods has a downward trend. It is recommended to choose the goods if the budget is limited.",
  rules73:
    "Save service fee, control the market price of goods accurately and buy goods for a long time.",
  rules74:
    "The supply of high-quality goods and the market price is stable or has an upward trend, the owner is not clear about the value of the supply and wants to sell at a higher price.",
  rules75:
    "Save service fee, price has clear psychological expectations of adviceChoose.",
  rules76: "Chapter III Settlement in kind",
  rules77: "Article 14",
  rules78:
    "After the successful transaction, the buyer and seller will handle the issue of the stock-out of the target of transaction, equity change, delivery, etc.",
  rules79: "Article 15",
  rules80:
    "Performance agreement: After the transaction, if either of the buyers and sellers have any act of breach or violation of contract (in line with any situation of deposit deduction), in addition to the performance of customer complaint process and deposit deduction, the customer will also be included in the customer blacklist of the Seafood Exchange, which will affect or restrict the participation in subsequent transactions.",
  rules81: "Chapter IV Supplementary Provisions",
  rules82: "Article 16",
  rules83:
    "The right of interpretation and revision of these Rules belong to the Seafood Exchange (Shenzhen International Tuna Trading Co., LTD.).",
  rules84: "Article 17",
  rules85:
    "The Seafood Exchange (Shenzhen International Tuna Trading Co., LTD.) has the right to revise and adjust the deposition rules according to the needs of the Seafood Exchange, and the revised rules will be notified to users through the website letter, website announcement and other appropriate ways. If the user continues to use the Seafood Exchange after the revision of the rules of transaction deposit and pays the deposit, it is deemed that the user has fully understood and accepted the revised rules of transaction deposit, and agrees that the Seafood Exchange manages the deposit paid by the user in accordance with the revised rules.",
  rules86: "Article 18",
  rules87:
    "Any dispute arising out of these Rules shall be settled by the parties through friendly negotiation. If no settlement can be reached through negotiation, the parties agree to submit the matter in dispute to the relevant arbitration department for arbitration in accordance with the arbitration rules in effect at the time of applying for arbitration. The arbitral award shall be final and binding upon all parties.",
  rules88: "Article 19",
  rules89:
    "The interpretation and implementation of these Rules shall be governed by the laws of Mainland China, and the determination of any provision of these Rules as invalid shall not affect the validity of the other provisions.",
  rules90: "Article 20",
  rules91: "These Rules shall take effect as of the date of promulgation.",
  contact1: "The phone number is 400-101-2799",
  contact2: "Email: mail@huacaizhaoyu.com",
  contact3:
    "Address: Room 601A, Building E1, Huateng Century Headquarters Park, Chenjialin Yard 9, Balizhuang, Chaoyang District, Beijing",
  contact4: "sweep",
  contact5: "View Mini apps",
  contact6: "Pay attention to",
  contact7: "WeChat Official Account",
  indexnew1:
    "Build a global online trading platform for high-end aquatic products",
  indexnew2:
    "Approved by Shenzhen Municipal Government, it is jointly initiated by China Agricultural Development Group and Shenzhen Port Group, with technical support from Beijing Huacai. As Shenzhen national oceangoing fishery base pilot project put into operation.",
  indexnew3: "Standardized rating pricing system",
  indexnew4: "Professional quality control team",
  indexnew5: "AI technology",
  indexnew6: "Trace the source",
  indexnew7: "Delivery system",
  indexnew8: "Delivery warehouse network",
  indexnew9: "Credit system",
  delivery1: "China International Seafood Exchange Global Delivery Warehouse",
  delivery2:
    "Provide global delivery services for high-end seafood on the exchange",
  delivery3:
    "The global delivery warehouses include the exchange's own delivery warehouses and delivery warehouses jointly built with domestic and foreign partners, covering important cities and ports in the main production and consumption areas of high-end seafood.",
  delivery4:
    "Internationalization, Standardization, Professionalization, Branding",
  delivery5:
    "The construction and development of global delivery warehouses provide more convenient, efficient, safe, and reliable delivery services for high-end seafood on the exchange, and expand the international influence and reputation of the exchange.",
  delivery6: "Covering major coastal distribution cities",
  delivery7:
    "Covering major coastal distribution cities in China: Dalian, Qingdao, Ningbo, Zhoushan, Fuzhou, Shenzhen, etc.; Covering China and East Asia: Tokyo, Busan, Bangkok, etc.;",
  delivery8: "Covering major coastal distribution centers",
  delivery9:
    "Covering major coastal distribution centers in China: Dalian, Qingdao, Zhoushan, Fuzhou, Shenzhen, Kaohsiung, etc. Covering China and East Asia: Tokyo, Busan, Bangkok, etc.",
  delivery10:
    "The China International Seafood Exchange Global Delivery Warehouse refers to the network of delivery warehouses established by the exchange around the world, which aims to provide global delivery services for high-end seafood on the exchange. The global delivery warehouses include the exchange's own delivery warehouses and delivery warehouses jointly built with domestic and foreign partners, covering important cities and ports in the main production and consumption areas of high-end seafood.",
  delivery11:
    'The construction and development of global delivery warehouses is an important part of the exchange\'s development strategy of "internationalization, standardization, professionalization, and branding". The construction and development of global delivery warehouses can provide more convenient, efficient, safe, and reliable delivery services for high-end seafood on the exchange, and expand the international influence and reputation of the exchange.',
  delivery12:
    "At present, the exchange has established a strategic partnership with VX Logistics Cold Chain. In the future, the exchange will continue to strengthen cooperation with domestic and foreign partners, expand the network and coverage of global delivery warehouses, improve the quality and efficiency of delivery services, and provide customers with more high-quality services and more convenient delivery methods.",
  delivery13:
    "Phased Construction and Development Plan of Delivery Warehouse Network:",
  delivery14:
    "Phase 1: Covering major coastal distribution cities in China: Dalian, Qingdao, Ningbo, Zhoushan, Fuzhou, Shenzhen, etc.;",
  delivery15:
    "Phase 2: Covering China and East Asia: Tokyo, Busan, Bangkok, etc.;",
  delivery16:
    "Phase 3: Covering major distribution cities in countries along the Belt and Road.",
  rksj: "Warehousing time",
  szjg: "Shenzhen price",
  nian: "Year",
  yue: "Month",
  zajzzz: "loading",
  flllll: "Classification",
  newwwwww: "-------------20240902----------------------------------",
  ccfw: "Warehousing Services",
  pkfw: "QC Services",
  qgfw: "Customs Clearance Services",
  hyqy: "Member Enterprises",
  ztgzhzsy: "Overall Rules Summary (Trial)",
  bzjxy: "Margin Agreement",
  grysjbhxy: "Personal Information Protection and Privacy Policy",
  xwzx: "News & Information",
  gjhczx: "International Seafood Information",
  gywm: "About Us",
  title1: "Searching the World in One Minute, One Stop Professional Service",
  title2:
    "Shenzhen International Tuna Trading Co., Ltd. was officially established on September 1, 2023, with the approval of the Shenzhen Municipal People's Government. It is committed to building Shenzhen International Seafood Exchange, and is put into operation as a pilot project of Shenzhen National Distant Water Fishery Base. It will help Shenzhen implement a three-year modern fishery development plan, strengthen fishery transformation, and build an international high-end aquatic product exchange integrating high-end aquatic product trading, display, warehousing, logistics, and finance.",
  kjmy: "Cross-Border Trade",
  title3: "Tailor-made strategic planning for you, down to every detail",
  title4: "Efficient Customs Clearance",
  title5:
    "Provide services of first cargo then tax to help domestic customers clear customs quickly Guarantee chain business efficiency",
  title6: "Ensure chain business efficiency",
  title7: "Worry-Free Procurement",
  title8:
    "Introduce financial institutions to help domestic buyers provide procurement financing services Improve procurement capabilities and help expand business scale",
  title9: "Improve purchasing capacity and help expand business scale",
  title10: "Process Risk Control",
  title11: "Operate according to the procedures stipulated in the agreement",
  title12: "Any process beyond the scope will be prohibited by the system",
  title13: "Transaction guarantee is more reassuring",
  title14: "Exchange Rate Hedging",
  title15:
    "Lock in exchange rates through bank's customer foreign exchange locking service",
  title16: "Control exchange rate risk",
  title17: "Manage procurement costs well",
  title18: "Price Management",
  title19: "Analyze product cycles and market conditions through big data",
  title20:
    "Make pre-judgments and automatically adjust the capital contribution ratio",
  title21: "Full Chain Solution",
  title22: "Let you have no worries throughout the entire process",
  title23: "Order Negotiation",
  title24: "Centralized Procurement",
  title25: "Documents",
  title26: "Payment/Financing Settlement",
  title27: "Cross-Border Logistics",
  title28: "Intelligent Customs Clearance",
  title29: "Financial and Tax Consulting Services",
  title30: "Warehouse Replacement",
  title31: "Logistics Transportation",
  title32: "Processing Services",
  title33: "Worry-Free Procurement, Helping Customers Optimize Cash Flow",
  title34: "More Flexible Funds, Easier Procurement, More Certain Finances",
  title35: "Down Payment",
  title36:
    "The final payment can be covered for downstream customers who meet the access conditions in China, alleviating inventory pressure, expanding business scale, and helping them seize domestic market share",
  title37: "Flexible Use of Funds",
  title38:
    "Borrow and repay at any time, borrowing and repaying funds as goods are purchased and sold",
  title39: "Foreign Exchange Hedging",
  title40:
    "Introduce financial institutions to provide services such as foreign exchange locking to domestic downstream customers to control procurement costs",
  title41: "Quick Experience",
  title42:
    "Online service, using and repaying funds according to orders, clear business, easier for domestic downstream customers to receive orders",
  title43: "Customs Clearance Services",
  title44:
    "Monthly summary of import customs clearance reports for each port, and provide professional customs clearance opinions on existing problems.",
  title45:
    "Timely send domestic inspection and quarantine and customs information on aquatic product imports and provide related solutions.",
  title46:
    "Our company currently cooperates with a number of customs clearance companies to provide customs clearance services to customers on our exchange.",
  title47: "Strong Ability to Resist Risks",
  title48:
    'The model of "determining procurement by sales" and "centralized procurement" has a strong ability to resist risks',
  title49: "Excellent Service Capability",
  title50: "Government-supported key enterprises to ensure people's livelihood",
  title51:
    "Systematic, Process-oriented, Information-based, and Intelligent Operation",
  title52:
    "IT system is in place, labor costs and maintenance costs are greatly reduced, forming a competitive barrier to peers",
  title53: "Customs Clearance Process",
  title54:
    "Accurately grasp every detail in the service and give you a satisfactory experience",
  title55: "Order",
  title56: "Transportation",
  title57: "Port Declaration",
  title58: "Inspection and Quarantine",
  title59: "Inspection and Release",
  title60: "Warehousing and Distribution",
  title61: "Value Positioning",
  title62: "Settlement Center",
  title63: "Logistic Center",
  title64: "Pricing Center",
  title65: "Standard Center",
  title66: "Big Data Center",
  title67: "Financial Service Center",
  title68: "7 Major Advantages",
  title69: "Cloud Trading",
  title70: "Buy and sell globally with one click, trading reaches unlimitedly.",
  title71: "Enhance decision accuracy through big data mining.",
  title72: "Local delivery in major distribution cities around the world,",
  title73: "reducing logistics costs.",
  title74: 'Restore the true information of the product, "one fish one code", ',
  title75: "to achieve 100% food safety.",
  title76:
    "All fishing quotas for distant water bluefin tuna are designated sales channels.",
  title77: "",
  title78:
    "Publish the actual transaction prices of global tuna distribution cities to help the Chinese market establish its position as a pricing center.",
  title79: "Intelligent Quality Inspection",
  title80:
    "AI image recognition enhances QC capabilities, reduces traditional fish inspection errors through unified testing standards, and improves application efficiency in multiple scenarios.",
  title81: "Exchange Introduction",
  title82:
    "Shenzhen International Tuna Trading Co., Ltd. was approved by the Shenzhen Municipal People's Government and initiated by China National Agricultural Development Group. It is a wholly-owned subsidiary controlled by CNFC Overseas Fisheries Co., Ltd. Shenzhen International Tuna Trading Co., Ltd. was officially established on September 1, 2023, and is committed to building Shenzhen International Seafood Exchange. It is put into operation as a pilot project of Shenzhen National Distant Water Fishery Base. It will help Shenzhen implement a three-year modern fishery development plan, strengthen fishery transformation, and build an international high-end aquatic product exchange integrating high-end aquatic product storage, trading, bidding, display, and consumption.",
  title83:
    "The exchange will take Shenzhen as the center, effectively linking high-end aquatic product distribution cities such as Dalian, Qingdao, Ningbo, Zhoushan, and Fuzhou, and gradually add delivery warehouses to achieve coverage of major high-end aquatic product trading cities around the world. It will actively help Shenzhen's modern fishery form a modern fishery industry cluster with international competitiveness, attractiveness, and influence.",
  title84: "Office ・ Shenzhen Haina Baichuan Building",
  title85: "Exchange Future Development Strategy",
  title86:
    'That is, taking high-end aquatic product trading as the core, building a three-dimensional online and offline trading system based on cloud trading and global delivery, gradually expanding the trading varieties and domestic and foreign delivery coverage; building a high-end aquatic product exchange based in the country, facing East Asia and South Asia, and serving countries and regions along the "Belt and Road," and linking high-end seafood in different places through remote digital exchanges and on-site bidding transactions to build a pattern of global high-end aquatic product circulation.',
  title87:
    "Build a service system for key nodes of global high-end seafood -- combining government policies in various countries and regions, building a service system around value-added service links such as fishing, aquaculture, transportation, refueling, warehousing, finance, processing, and QC rating in the core production areas of high-end seafood, controlling key resources at the front end of the industrial chain, and building a stable and high-quality supply base. Build a channel sinking service system for central node cities in the sales area -- establish service systems such as trunk line logistics, forward warehouses, and urban distribution in directly-administered municipalities and provincial capital cities such as Beijing, Shanghai, Guangzhou, Shenzhen, Chengdu, Chongqing, and Wuhan through cooperation models.",
  title88: "Cold Chain Warehousing",
  title89:
    "Provide integrated cold chain services such as cargo cold storage, sorting, packaging, distribution, and information flow",
  title90: "Multi-Temperature Zone Control",
  title91: "Multi-Temperature Zone Storage",
  title92: "24/7 temperature monitoring, process traceable",
  title93: "Wide Coverage",
  title94: "Through the coverage range of each warehouse",
  title95: "Dry and distribution can cover most areas of Mainland China",
  title96: "Multi-Category Service",
  title97: "Bulk-In-Piece-Out",
  title98: "Provide small batch multi-category operation services",
  title99: "National Branch Warehouse",
  title100: "Provide branch warehousing services in mainland China",
  lang1: "QC service refers to the service of QC and supervision of seafood.",
  lang2:
    "It aims to ensure that the quality of seafood meets relevant standards and requirements.",
  lang3:
    "Through the monitoring and control of product quality, it is ensured that the freshness, appearance, and other indicators of seafood meet quality standards.",
  lang4: "Service Content",
  lang5: "Raw Material Inspection",
  lang6:
    "Inspect aquatic product raw materials, including fish, shrimp, shellfish, etc., to ensure the quality and safety of raw materials.",
  lang7: "Process Monitoring",
  lang8:
    "Monitor the production process of seafood, including processing, freezing, packaging, and other links, to ensure that each link meets quality standards and operating procedures.",
  lang9: "Quality Spot Check",
  lang10:
    "Conduct regular quality spot checks on frozen products, including inspections of appearance, taste, nutritional components, etc., to ensure that the quality of the products meets the standards.",
  lang11: "Label and Packaging Inspection",
  lang12:
    "Inspect the labels and packaging of seafood to ensure that the product identification and packaging meet regulatory requirements, provide correct product information, and protect the integrity of the products.",
  lang13: "Supply Chain Management",
  lang14:
    "Manage and monitor the supply chain of seafood, including supplier evaluation, logistics management, etc., to ensure that the source and destination of the products are traceable, and to ensure the stability and reliability of the supply chain.",
  lang15: "Service Advantages",
  lang16:
    "QC services can ensure that the quality of seafood meets relevant standards and requirements Reduce product quality problems and food safety risks",
  lang17: "Reduce product quality issues and food safety risks",
  lang18:
    "Through QC services, a good brand image and reputation can be established for enterprises Enhance consumers' trust and loyalty to products",
  lang19: "Enhance consumer trust and loyalty to the product",
  lang20:
    "QC services can improve the market competitiveness of seafood Meet consumers' demand for high-quality products, increase product sales and market share",
  lang21:
    "Meet consumer demand for high-quality products, increase product sales and market share",
  lang22:
    "QC services can provide data analysis and improvement suggestions to help enterprises understand product quality status and market demand, optimize product quality and production processes, and achieve continuous improvement",
  lang23:
    "Condition and market demand, optimize product quality and production process, achieve continuous improvement",
  lang24: "Change the profile picture",
  lang25: "ID",
  lang26: "My name",
  lang27: "Payment password",
  lang28: "Edit",
  lang29: "Settings",
  lang30: "Filled",
  lang31: "Principal name",
  lang32: "Add new principal",
  lang33: "Company Email",
  lang34: "Business operation mailbox",
  lang35: "Customer service email",
  lang36: "Company profile",
  lang37:
    "The company is mainly engaged in the production and management of ocean fishing, the main products are tuna and fish species and other seafood and processed products. The company has three business segments: low-temperature tuna fishing, ultra-low temperature tuna fishing and aquatic products trading. With more than 70 tuna fishing vessels, it is a professional company specializing in tuna longline fishing with the largest scale, the widest range of operations, the highest product output and the most complete types of tuna in China. In the tuna fishing vessel equipment, production capacity, management technology, talent reserves and other aspects are in the domestic leading level. The company has more than 10 branches at home and abroad.",
  lang38: "Application Process",
  lang39: "Register an exchange account",
  lang40: "Complete enterprise certification",
  lang41: "Review materials passed",
  lang42: "Apply to join member enterprises",
  lang43: "Data review",
  lang44: "Become a member Enterprise",
  lang45: "Apply to Become a Member Enterprise Now",
  lang46: "Financial Services",
  lang47: "Port clearance",
  lang48: "Service introduction",
  lang49:
    "The global delivery warehouse includes the trading platform's own delivery warehouse and the delivery warehouse built with domestic and foreign partners, covering important cities and ports in major tuna production and consumption areas.",
  lang50: "Service process",
  lang51:
    "The company is mainly engaged in the production and management of ocean fishing, the main products are tuna and fish species and other seafood and processed products. The company has three business segments: low-temperature tuna fishing, ultra-low temperature tuna fishing and aquatic products trading. With more than 70 tuna fishing vessels, it is a professional company specializing in tuna longline fishing with the largest scale, the widest range of operations, the highest product output and the most complete types of tuna in China. In the tuna fishing vessel equipment, production capacity, management technology, talent reserves and other aspects are in the domestic leading level. The company is mainly engaged in the production and management of ocean fishing, the main products are tuna and fish species and other seafood and processed products.",
  lang52:
    "The company has three business segments: low-temperature tuna fishing, ultra-low temperature tuna fishing and aquatic products trading. With more than 70 tuna fishing vessels, it is a professional company specializing in tuna longline fishing with the largest scale, the widest range of operations, the highest product output and the most complete types of tuna in China. In the tuna fishing vessel equipment, production capacity, management technology, talent reserves and other aspects are in the domestic leading level. The company is mainly engaged in the production and management of ocean fishing, the main products are tuna and fish species and other seafood and processed products. The company has three business segments: low-temperature tuna fishing, ultra-low temperature tuna fishing and aquatic products trading.",
  lang53: "Pay attention to new developments",
  lang54: "Clear a new direction",
  lang55: "source",
  lang56: "give a like",
  lang57: "Already Liked",
  lang58: "Build a new ecology",
  lang59: "Win-win cooperation",
  lang60: "Click successful",
  lang61: "My Deal (Buy)",
  lang62: "My Deal (Sell)",
  lang63: "Order details",
  lang64: "This order",
  lang65: "Order creation time",
  lang66: "First service charge",
  lang67: "The first",
  lang68: "Total first payables",
  lang69: "Total first receivable",
  lang70:
    "The final transaction tonnage is subject to the actual tonnage out of the warehouse, more return less make up.",
  lang71: "Balance sheet date",
  lang72: "Final payment service charge",
  lang73: "Balance payment",
  lang74: "Total balance payable",
  lang75: "Total receivable on the balance",
  lang76: "Total amount refundable",
  lang77: "Total amount refundable",
  lang78: "Actual delivered weight",
  lang79: "Gross transaction",
  lang80: "The total",
  lang81: "Buyer's customer",
  lang82: "Mine",
  lang83: "Buyer's bank card",
  lang84: "Seller's customer",
  lang85: "Seller's bank card",
  lang86: "Operator",
  lang87: "Shipping accessories",
  lang88: "Receiving attachment",
  lang89: "Quality control",
  lang90: "Invoice",
  lang91: "Check the invoice",
  lang92: "View the transaction details",
  lang93: "Download service charge receipt",
  lang94: "Online contract signing SMS has been sent...",
  lang95: "Receiving phone number",
  lang96: "Please pay attention to the text message and sign in time.",
  lang97: "I know.",
  lang98: "Postponement of balance",
  lang99: "Put off to",
  lang100: "Initiating supplementary agreement",
  lang101: "Sign a supplementary agreement",
  lang102:
    "The revised terms of this Contract shall take effect only after the parties have fully negotiated and reached a consensus, and shall be signed and confirmed by all three parties involved in the original contract.",
  lang103: "Currently, only [container number] can be modified",
  lang104: "Original container number",
  lang105: "New container number",
  lang106: "Please enter a new container number",
  lang107: "I acknowledge and agree to the above",
  lang108: "Fill in the port of destination.",
  lang109: "Please fill in after consultation with the buyer",
  lang110: "Destination port",
  lang111: "The departure port cannot be empty",
  lang112: "Operation log",
  lang113: "Principal name",
  lang114: "Operation content",
  lang115: "Operating time",
  lang116: "Please select a date",
  lang117: "Successful extension",
  lang118:
    "This operation will [pay the warehouse receipt], do you want to continue?",
  lang119: "Tips",
  lang120:
    "Cancellation of the order is a breach of contract and the frozen deposit will be deducted.",
  lang121: "Do you confirm to cancel the order?",
  lang122: "Cancel successfully",
  lang123: "File download failure",
  lang124: "Sale of goods",
  lang125: "Switching Agent",
  lang126: "Account association",
  lang127: "Master account information",
  lang128: "Current login account",
  lang129: "Legal person",
  lang130: "Principal account",
  lang131: "Subaccount list",
  lang132: "Add an account",
  lang133: "No subaccount information,",
  lang134: "Go Add",
  lang135: "Subaccount role",
  lang136: "Account owner",
  lang137: "Bind mobile No.",
  lang138: "Controls",
  lang139: "Edit and modify",
  lang140: "Unbind account",
  lang141: "Information about the current subaccount",
  lang142: "Edit subaccount",
  lang143: "Add a subaccount",
  lang144: "FINANCE",
  lang145: "Trader",
  lang146: "Please select a subaccount role",
  lang147: "Account owner information",
  lang148:
    "Ensure that the photo content is true and valid and cannot be modified in any way. Only jpg, jpeg, png, and gif formats are supported. The image size cannot exceed 10M",
  lang149: "Please complete the following information",
  lang150: "Responsible person's mobile number",
  lang151: "Not the current login account",
  lang152: "Enter again to confirm the content",
  lang153: "mobile No. of current account",
  lang154: "Get it again in ** seconds",
  lang155: "I have read and agreed to the",
  lang156: "Sub-account Addition Agreement",
  lang157: "Submit subaccount information",
  lang158: "Please read and agree to the Sub-Account Addition Agreement",
  lang159: "Please enter the phone number of the person in charge",
  lang160: "Please enter the phone number of the person in charge again",
  lang161: "This operation unbinds the bond. Do you want to continue?",
  lang162: "Unbind successfully",
  lang163: "Upload picture size cannot exceed 10MB!",
  lang164: "Person Likes",
  lang165: "Transaction of interest",
  lang166: "List of customs declarations",
  lang167: "Customs declaration number",
  lang168: "Production ship",
  lang169: "Trade name",
  lang170: "Declarable quantity",
  lang171:
    "If your source belongs to Shenzhen local fishing back goods, please contact the dedicated customer service to upload the customs declaration form",
  lang172: "Personal Account",
  lang173: "Warehouse Receipt Management",
  lang174: "Warehouse Receipt Entry",
  lang175: "Audit Record",
  lang176: "Original Warehouse Receipt",
  lang177: "Registered Warehouse Receipt",
  lang178: "Invoice Assistant",
  lang179: "Customs Declaration",
  lang180: "Rule",
  lang181: "Please select",
  lang182: "Billing record",
  lang183: "Order item specifications",
  lang184: "Order time",
  lang185: "The invoice amount is subject to the actual invoice",
  lang186:
    "This feature is only applicable to the platform service fee incurred in the transaction;",
  lang187:
    "Service charge cannot be combined, invoice and order will correspond one by one.",
  lang188: "next",
  lang189: "Selected",
  lang190: "An order will be issued",
  lang191: "An invoice",
  lang192: "Invoicing order available",
  lang193: "No invoicing orders",
  lang194: "Please select at least one order",
  lang195: "Service charge invoice",
  lang196: "Invoice type",
  lang197: "Billing record",
  lang198: "Number of included orders",
  lang199: "Invoicing application time",
  lang200: "amount",
  lang201: "Transfer deposit",
  lang202: "Transfer to bank card",
  lang203: "Call-in list",
  lang204: "Refresh",
  lang205: "NO.",
  lang206: "Initiation time",
  lang207: "Cancel transfer",
  lang208: "Please confirm the margin transfer information",
  lang209: "Amount paid",
  lang210: "Name of the recipient",
  lang211: "Recipient's account",
  lang212: "Receiving bank",
  lang213: "Bank link number",
  lang214: "Postscript",
  lang215: "The amount transferred must be numeric and greater than 0",
  lang216: "Please select a bank card",
  lang217:
    "This operation will [cancel the transfer], do you want to continue?",
  lang218: "Transfer deposit",
  lang219: "The amount transferred out must be numeric and greater than 0",
  lang220: "Settlement record",
  lang221: "Settlement record details",
  lang222: "Warehouse receipt number",
  lang223: "Warehouse name",
  lang224: "Original warehouse certificate number",
  lang225: "Specification name",
  lang226: "Commodity quantity",
  lang227: "Seller's company",
  lang228: "Transfer time",
  lang229: "Contract number",
  lang230: "Please enter a keyword to search",
  lang231: "Search",
  lang232: "Pass the examination",
  lang233: "Original warehouse receipt number",
  lang234: "Application time",
  lang235: "Audit rejected",
  lang236: "Cause of rejection",
  lang237: "Go to modify",
  lang238: "Please select a warehouse name",
  lang239: "Attached picture",
  lang240: "Please click Upload",
  lang241: "Original document number",
  lang242: "Please select a category",
  lang243: "Place of origin",
  lang244: "Please select the place of origin",
  lang245: "Freezing method",
  lang246: "Please select the freezing method",
  lang247: "Port of discharge",
  lang248: "Please select the port of discharge",
  lang249: "Warehouse receipt picture",
  lang250: "Fishing method",
  lang251: "Please select a fishing method",
  lang252: "Place of entry",
  lang253: "Please select the place of declaration",
  lang254: "Production ship number",
  lang255: "Customs declaration number",
  lang256: "Entry time",
  lang257: "Production of ship number enterprises",
  lang258: "Bill of lading number",
  lang259: "Size",
  lang260: "Quantity (tons)",
  lang261: "Please select specifications",
  lang262: "Please click Enter (digits only, up to 4 decimals)",
  lang263: "New",
  lang264: "Total",
  lang265: "Submit warehouse receipt",
  lang266: "Please fill in the original voucher number",
  lang267:
    "Please enter the correct number (must be a number, up to four decimals)",
  lang268: "Upload a maximum of 9 images",
  lang269:
    "Only one photo is allowed. If you need to modify it, delete it and upload it again",
  lang270: "Please improve the specification, quantity (ton) information",
  lang271: "Submitted successfully, please wait for review",
  lang272: "Warehouse receipt details",
  lang273: "Last change time",
  lang274: "Production ship owned enterprises",
  lang275: "Cancellation of warehouse receipt",
  lang276:
    "After cancellation, the receipt will be returned to the “original receipt”",
  lang277:
    'Registered warehouse receipts can be used for "Linked Warehouse Receipts" transactions',
  lang278: "Check the settlement record",
  lang279: "Change the bank card",
  lang280:
    "The drop-down list displays only the latest 100 pieces of data, if you need more, please enter the exact information",
  lang281: "Bank card account phone number",
  lang282: "Must be 【 Bank card account number 】",
  lang283: "Changing the Account Opening Agreement...",
  lang284:
    "Please pay attention to the mobile phone message, and go to sign the agreement, after signing, you can change the bank card successfully.",
  lang285: "Please remind legal persons to pay attention to mobile phone SMS",
  lang286: "And went to sign the agreement.",
  lang287: "Please enter the bank card account phone number",
  lang288: "Change bank card",
  lang289: "Please check the withdrawal information",
  lang290: "Please enter your payment password",
  lang291:
    "Please enter a combination of 8-10 letters and digits, case insensitive",
  lang292: "Don't have a payment password yet?",
  lang293: "Set a payment password",
  lang294: "The withdrawal amount must be numeric and must be greater than 0",
  lang295: "Successful withdrawal",
  lang296: "If the roll-out exception occurs, contact the administrator",
  lang297: "Payment password is incorrect, please re-enter",
  lang298: "Publication of trading rankings",
  lang299: "Time frame",
  lang300: "National Ranking",
  lang301: "Ranking",
  lang302: "Name",
  lang303: "Turnover (Yuan)",
  lang304: "No ranking ~",
  lang305: "Shenzhen List",
  lang306: "Account Opening Agreement",
  lang307: "Breach of Contract Agreement",
  lang308: "Information Service Agreement",
  lang309: "Trader Service Agreement",
  lang310: "Procurement Services Agreement",
  lang311: "Account Association Agreement",
  lang312: "Tripartite Agreement on Trading Platform Fund Settlement Service",
  lang313: "China International Seafood Exchange Personal User Trading Rules",
  lang314: "Rule catalog",
  lang315: "Platform Rules Details",
  lang316: "Certified account opening",
  lang317:
    "After opening an account successfully, you can participate in the platform trading",
  lang318:
    "When the agreement is signed, you can participate in the platform trading after the account is successfully opened",
  lang319: "",
  lang320: "Re-open an account",
  lang321: "Authentication account opening failed, please",
  lang322: "Failure to sign contract",
  lang323: "Reinitiate protocol",
  lang324: "Enterprise information registration",
  lang325: "Registration successful, please",
  lang326: "Go to open account",
  lang327: "Edit personal data",
  lang328: "Click to publish bid",
  lang329: "Click to publish Listing",
  lang330: "Open account",
  lang331: "View details",
  lang332: "Data statistics",
  lang333: "Number of customers viewed (persons)",
  lang334: "Number of trading clients (persons)",
  lang335: "Sales amount (Yuan)",
  lang336: "Purchase amount (Yuan)",
  lang337: "The current account is not opened and cannot be viewed",
  lang338: "The Account Opening Agreement is being generated..",
  lang339:
    "Please remind the legal person to pay attention to the mobile phone message and go to sign the agreement. After signing, the account can be opened successfully.",
  lang340:
    "The current account has not been opened and has no publishing permission",
  lang341:
    "The account opening agreement is being signed, and there is no publishing permission",
  lang342: "This account does not support the release of goods sources",
  lang343: "When the market opens",
  lang344: "Market closed",
  lang345: "From Monday to Friday(Except National Holidays)",
  lang346: "09:00am-11:30am",
  lang347: "01:00pm-4:30pm",
  lang348: "The category section",
  lang349: "Please enter keywords",
  lang350: "Recent search",
  lang351: "Bid price",
  lang352: "Hang one's hat",
  lang353: "The highest price",
  lang354: "One-click replication",
  lang355: "Unavailable",
  lang356: "Deal only",
  lang357: "Check the statement",
  lang358: "Estimated gross tonnage (tons)",
  lang359: "Estimated average price (Yuan/ton)",
  lang360: "Actual gross tonnage (tons)",
  lang361: "Adjusted average price (Yuan/ton)",
  lang362: "Final statement",
  lang363: "View",
  lang364: "Download",
  lang365: "Total payment for goods",
  lang366: "Paid by buyer",
  lang367: "Balance payment",
  lang368: "Service charge",
  lang369: "Aggregate payable",
  lang370: "Refundable amount",
  lang371: "Buyer's payable",
  lang372: "Initiate the final payment",
  lang373: "Click to upload",
  lang374: "Please enter the actual tonnage",
  lang375: "Please enter a number, including up to four decimals",
  lang376: "Please enter the actual average price",
  lang377: "Upload attachment size cannot exceed 200MB!",
  lang378: "Upload a maximum of 1 attachment",
  lang379: "Please upload the statement",
  lang380: "Successful initiation",
  lang381: "Final confirmation",
  lang382: "Initial estimate",
  lang383: "No data available",
  lang384: "Category",
  lang385: "Carton number",
  lang386: "The number of boxes cannot be empty",
  lang387: "Please enter an integer",
  lang388: "Please Enter",
  lang389: "Carton weight",
  lang390: "The box weight cannot be empty",
  lang391: "Total net weight",
  lang392: "Transaction price",
  lang393: "Return rate",
  lang394: "Please enter a number with a maximum of two decimals",
  lang395: "Unit price",
  lang396: "Total amount",
  lang397: "Please complete the form information",
  lang398: "Current high",
  lang399: "Number of rows",
  lang400: "The unit price cannot be empty",
  lang401: "Click to edit",
  lang402: "Total",
  lang403: "Your bid",
  lang405: "The range of this price increase",
  lang406: "Return to modify",
  lang407:
    "The current bid is less than the current maximum price and cannot be bid",
  lang408: "Countdown",
  lang409: "Days",
  lang410: "Bid details",
  lang411: "Bid time",
  lang412: "Off",
  lang413: "Current margin",
  lang414: "Your entry deposit",
  lang415:
    "The amount of deposit required for this transaction is not less than",
  lang416:
    "If you have sufficient funds in your margin account, you can sign up directly.",
  lang417:
    "If you fail to perform the contract after successful auction, the Platform reserves the right to deduct your entry deposit.",
  lang418: "Registration bidding",
  lang419: "Deposit is insufficient, go to transfer.",
  lang420: "Customs declaration selection",
  lang421: "Confirm selection",
  lang422: "Warehouse receipt number",
  lang423: "Obtaining location information",
  lang424: "Click to get location",
  lang425: "Map",
  lang426: "Enter the address search point information",
  lang427: "Current position",
  lang428: "Check total weight",
  lang429: "box",
  lang430: "Number of transaction boxes",
  lang431: "Original trading weight",
  lang432: "Please enter the total transaction weight",
  lang433: "The value fluctuates greatly, please check it.",
  lang434: "Date",
  lang435: "Price(CNY)",
  lang436: "Login to discover more exciting features!",
  lang437: "Hotline ",
  lang438: "Map point selection",
  lang439: "Currently selected address",
  lang440: "If you need this service, please leave your contact information",
  lang441: "Service Application",
  lang442: "Hotline ",
  lang443: "Company Name",
  lang444: "Please enter the business name",
  lang445: "Apply for",
  lang446: "Phone No.",
  lang447: "The application is successful",
  lang448: "Pack up",
  lang449: "Default",
  lang450: "Distance Priority",
  lang451: "Screen",
  lang452: "Roll-in and roll-out details",
  lang453: "Type of operation",
  lang454: "Transaction amount",
  lang455: "Bank card",
  lang456: "Deposit or not",
  lang457: "Earnest money",
  lang458: "Thawed state",
  lang459: "Forward detail",
  lang460: "roll-out",
  lang461: "Status",
  lang462: "Roll-out exception, please apply again",
  lang463: "Rolling out",
  lang464: "Rolled out",
  lang465:
    "In order to protect the rights and interests of the buyer's customers, if there are unfinished transactions under the current account or the completed transactions are less than 7*24 hours, the deposit shall not be less than 100,000 yuan.",
  lang466: "Business license information",
  lang467: "Legal person information",
  lang468: "Operator information",
  lang469: "Bank card information",
  lang470: "Validity period of business license",
  lang471: "Please enter the business license validity period",
  lang472: "Total assets",
  lang473: "Please enter total assets (Yuan)",
  lang474: "Operating income in recent one year (Yuan)",
  lang475: "Please enter the last year's operating income (Yuan)",
  lang476: "Practitioner",
  lang477: "Please enter the employee information",
  lang478: "Corporate name",
  lang479: "Please enter the legal person name",
  lang480: "Legal person ID number",
  lang481: "Please enter the corporate ID number",
  lang482: "Validity period of corporate identity card",
  lang483: "Please enter the legal person ID card validity period",
  lang484: "Legal person mobile No.",
  lang485: "Please enter the French phone number",
  lang486:
    "The legal person needs to sign the Account Opening Agreement, please confirm that the mobile No. is correct.",
  lang487: "Please upload a photo of the handler",
  lang488: "Name of the handler",
  lang489: "Please enter the name of the handler",
  lang490: "Handler ID number",
  lang491: "Please enter the handler ID number",
  lang492: "The validity period of the agent's ID card",
  lang493: "Please enter the validity period of the handler's ID card",
  lang494: "Please enter your bank card number",
  lang495: "Please enter account bank search and select from the drop-down box",
  lang496: "Sign in",
  lang497: "After signing, the account can be opened successfully.",
  lang498: "The Unified Social credit code cannot be empty",
  lang499: "Unified social credit code input error, please check carefully",
  lang500: "Please enter the number",
  lang501: "Please upload corporate ID photo portrait",
  lang502: "Please upload a photo of your corporate ID card",
  lang503: "Please upload the agent ID photo portrait face",
  lang504: "Please upload the agent ID photo national emblem face",
  lang505: "Billing information",
  lang506: "Invoicing",
  lang507: "Service charge invoice",
  lang508:
    "Invoice information (Invoice information is account opening information and cannot be changed)",
  lang509: "Header type",
  lang510: "Enterprise unit",
  lang511: "Individuals/non-business units",
  lang512: "Company tax number",
  lang513: "Invoice amount",
  lang514: "** invoices are expected to be issued",
  lang515: "Order details",
  lang516: "Item specification",
  lang517: "Order number",
  lang518: "Including 1 order, 1 invoice will be issued",
  lang519: "1 invoice, including 1 order",
  lang520: "Receiving mode",
  lang521: "E-mail",
  lang522: "Please enter your email",
  lang523: "Resend",
  lang524: "Sex",
  lang525: "Add new bank card",
  lang526: "Sign OUT",
  lang527: "View Platform Account",
  lang528: "Platform account information",
  lang529: "Please enter",
  lang530: "Type of bank",
  lang531: "Add",
  lang532: "Do you want to cancel the bank card?",
  lang533: "Logout successful",
  lang534: "Content copied",
  lang535: "Add successfully!",
  lang536: "Release details",
  lang537: "Upload attachment",
  lang538: "Estimated tonnage",
  lang539: "Actual tonnage delivered",
  lang540: "Please enter the tonnage",
  lang541:
    "If the actual tonnage delivered is different from the expected transaction tonnage, the amount involved is adjusted, and the supplementary agreement must be signed",
  lang542: "Please upload the attachment",
  lang543: "(Supports uploading pictures, pdf,excel,word files, up to 9 files)",
  lang544: "Drag the file here, or click Upload",
  lang545: "Please enter the actual outbound tonnage",
  lang546:
    "The actual tonnage shipped out should be a number, with a maximum of 4 decimal places",
  lang547: "Successful release of goods",
  lang548: "Successful receipt of goods",
  lang549:
    "Please use the attached bank card to transfer money to the following account",
  lang550: "Recipient's bank connection number",
  lang551: 'Please copy the postscript and fill it in the "Purpose" field',
  lang552: "Actual tonnage",
  lang553: "Estimated tonnage",
  lang554: "Payment due",
  lang555: "Paid total",
  lang556: "Please select a bank account to pay",
  lang557: "Do not use other bank accounts to pay, otherwise",
  lang558: "Payment failure",
  lang559:
    "If the single bank account limit is less than the total amount paid out, click Select",
  lang560: "Documentary payment",
  lang561: "Skip payment",
  lang562: "Check payment status",
  lang563: "Cancel an order",
  lang564: "Open order",
  lang565: "The minimum number of demolitions is 2 and the maximum is 50",
  lang566: "After paying any order, the order cannot be reset",
  lang567:
    "Please confirm this order carefully. After confirming, please click",
  lang568: "Confirmation release",
  lang569: "The order cannot be cancelled or reset after clicking",
  lang570: "Order number",
  lang571: "Go to pay",
  lang572: "Have paid",
  lang573: "Payment completion",
  lang574:
    "I have not found the account opening information, I need to go to [My account] to open an account",
  lang575:
    "Please enter the number of orders. The minimum number of orders is 2 and the maximum number is 50",
  lang576: "Please select your payment card first",
  lang577: "Payment not transferred",
  lang578: "Please confirm the transfer information",
  lang579: "The payment has been transferred",
  lang580: "Change payment password",
  lang581: "Change payment password",
  lang582: "Please combine 8-10 letters and numbers again, case insensitive",
  lang583: "The two passwords are different",
  lang584: "I am certified to have read and fully understood the above",
  lang585: "Agree and continue",
  lang586:
    "Registration and bidding shall be paid by the legal person or the financial department of the corresponding performance bond;",
  lang587:
    "If the auction is not awarded, the performance bond will be automatically refunded to the original account",
  lang588:
    "If the auction is successful, the performance bond will be automatically refunded to the original account after you have paid the full amount",
  lang589:
    "If the contract is not performed after the successful auction, the performance bond will be deducted",
  lang590: "After payment is complete, please click",
  lang591: "After payment, check the registration status",
  lang592: "Confirm registration is successful.",
  lang593: "The performance bond payment channel is as follows",
  lang594: "Payment link",
  lang595:
    "Note: Please copy the postscript into the purpose when transferring",
  lang596: "Successful replication",
  lang597: "The highest",
  lang598: "Release time",
  lang599: "Transaction date",
  lang600: "End date",
  lang601: "Add follow success",
  lang602: "Unfollow success",
  info1: "Multi-specification",
  info2: "Loading",
  info3: "Purse Seine presale",
  info4: "The ratio of the first and last payment",
  info5:
    "The first and last payment does not include service fee and is subject to the actual settlement",
  info6: "First amount",
  info7: "Balance amount",
  info8: "The total value is above the latest offer",
  info9: "Days of bidding",
  info10: "Number of delays",
  info11: "Number of Viewers",
  info12: "people",
  info13: "Delivery will be delayed by ** hours after transaction",
  info14: "Q&A",
  info15: "Settlement start and end date",
  info16: "Unfollow",
  info17: "Settlement method",
  info18:
    "The first and last payment does not include service fee; The initial and final payment will change with the bidding process; The first and last payment is subject to the actual settlement.",
  info19: "Current price",
  info20: "A total of ** article",
  info21: "Bid",
  info22: "Leading",
  info23: "Die out",
  info24: "Form of supply",
  info25: "Brand",
  info26: "Factory number",
  info27: "Production date",
  info28: "Attached data",
  info29: "Sea temperature",
  info30: "Container number",
  info31: "Remark clause",
  info32: "Place of dispatch",
  info33: "Single settlement",
  info34: "First and last payment model",
  info35: "Fish information",
  info36: "Fixed weight",
  info37: "Weigh (on the scale)",
  info38: "Settlement form",
  info39: "Number of packages",
  info40: "Piece weight",
  info41: "Fish species, specifications and unit price are as follows",
  info42:
    "Note: Through negotiation, the pre-sale price of this batch of goods is 1 ** yuan/ton, and the actual transaction price is settled according to the market price at that time",
  info43: "Fish body",
  info44: "Tag",
  info45: "Gills",
  info46: "Ice mass",
  info47: "Product traceability documents",
  info48: "Gross weight",
  info49: "Cases purchased",
  info50:
    "The following is only an estimate, and the actual calculation is based on the weight calculated by the seller",
  info51: "First scale",
  info52: "Balance ratio",
  info53: "Estimated balance",
  info54: "Estimated service charge",
  info55: "Total payable",
  info56: "Estimated total payable",
  info57: "Purchasing enterprise",
  info58: "Confirmation of purchase",
  info59:
    "Dear user, your number/amount of transactions today has reached the upper limit of the current level. For the sake of your account security and trading experience, please pay attention to our trading rules, or contact customer service to find out how to improve your user status.",
  info60: "Click to read",
  info61: "Please select a payment account",
  info62: "Please fill in the number of boxes purchased as required",
  info63: "Successful purchase",
  info64: "The number of boxes purchased cannot be empty",
  info65:
    "The number of boxes purchased cannot be lower than the number of boxes for sale",
  info66: "Current enterprise",
  info67: "Set up payment card",
  info68: "Please select the type of source you want to trade",
  info69: "Warehouse receipt transaction",
  info70: "Spot transaction",
  info71: "Self-fishing bidding",
  info72: "Salmon trading",
  info73:
    "Does the platform need manual intervention to participate in the delivery process?",
  info74:
    "Autonomous delivery, no need for platform quality control intervention",
  info75:
    "Platform delivery, delivery will have quality control personnel arrive at the scene",
  info76: "Please select the current enterprise",
  info77: "Please set up payment card",
  info78:
    "Please select platform manual intervention to participate in the delivery process",
  info79: "Step 1 Associate warehouse receipts",
  info80: "Step 2 Bid setting",
  info81: "Step 2 Trade information",
  info82:
    "If the source of self-captured goods is involved, please select the corresponding customs declaration number",
  info83: "Can't find the customs form you need? tap",
  info84: "Contact customer service",
  info85: "Click on Select Declaration Form",
  info86: "Change binding",
  info87: "Associated warehouse receipt",
  info88: "Please select associated receipt",
  info89: "Commodity information",
  info90: "Optional parameter",
  info91: "Select date",
  info92: "Back",
  info93: "Save as Draft",
  info94: "Quantity",
  info95: "Total price",
  info96: "Starting price (Yuan/ton)",
  info97: "Price increase (Yuan/ton)",
  info98: "Please confirm to fill in the information",
  info99: "Transaction information",
  info100: "Re-edit",
  info101: "Unsubmit",
  info102: "Confirm submission",
  info103: "Submit it in five minutes",
  info104: "This transaction will be submitted after **",
  info105: "Drafts",
  info106: "Title",
  info107: "This action will delete the draft. Do you want to continue?",
  info108: "Plug into this draft",
  info109: "Please select the warehouse receipt",
  info110: "Please enter the port of discharge",
  info111: "Please select product information",
  info112: "Please enter price information",
  info113: "Please select a unit",
  info114: "Please enter weight",
  info115: "Please enter the total price",
  info116: "Please enter the bidding date",
  info117: "Please enter bidding time",
  info118: "Please enter bidding duration",
  info119: "Please enter the starting bid",
  info120: "Please enter the price increase (Yuan/ton)",
  info121: "The unit price is empty and cannot be calculated",
  info122: "Have saved as a draft, please click [draft box] to view",
  info123: "Please upload the source photo",
  info124: "The price you set is too low, please confirm it.",
  info125: "Confirm",
  info126: "Back to edit",
  info127: "Cancel submission successfully",
  info128: "Step 1 Order information",
  info129: "Step 1 Source information",
  info130: "Step 2 Bid setting",
  info131: "Step 2 Set up the listing",
  info132: "Step 3 Delivery setup",
  info133: "Please enter the title",
  info134: "The product name cannot be empty",
  info135: "The specification cannot be empty",
  info136: "Total net weight cannot be empty",
  info137: "Quantity (box)",
  info138: "Please select brand",
  info139: "Please select the factory number",
  info140: "Specification and size",
  info141: "Delivery address",
  info142: "Please enter country, region or port of shipment",
  info143: "Please select sea temperature",
  info144: "Custom sea temperature (° C)",
  info145: "to",
  info146: "Starting month",
  info147: "End month",
  info148: "Fishing vessel name",
  info149: "Please enter the name of the fishing vessel",
  info150: "Name of the carrier",
  info151: "Please enter the ship name",
  info152: "(Upload photos, up to 30 photos)",
  info153: "(Upload photos, one for each)",
  info154: "Certificate",
  info155:
    "You can only upload pdf,excel, and word files with a maximum size of 20M",
  info156: "Pricing options",
  info157: "Fixed price",
  info158: "Tiered pricing",
  info159: "Minimum number of boxes for sale",
  info160: "Please enter the minimum number of boxes for sale",
  info161: "Please enter the number of boxes",
  info162: "Box number interval",
  info163: "Price (Yuan /kg)",
  info164: "Please enter price",
  info165:
    "Sellers can only register before the bidding starts, please allow enough time.",
  info166: "Starting bid (Yuan)",
  info167: "Increment interval",
  info168: "Arbitrary point in time",
  info169: "Bidding type",
  info170: "Short-time bidding",
  info171: "Long-term bidding",
  info172: "Bidding days",
  info173: "Please enter bidding days",
  info174: "Please select bidding duration",
  info175: "Expected to end at **;",
  info176:
    "If there is a bid 2 hours before the end of the bidding, the bidding will automatically be extended for 24 hours;",
  info177: "Bidding days do not include closing hours.",
  info178: "Delivery mode",
  info179: "Spot delivery",
  info180: "Forward delivery",
  info181: "Delivery time",
  info182: "Lead time for stock replenishment",
  info183: "Total value of goods",
  info184: "The sum of the first and last payment is 100%",
  info185: "The latest date for the final payment",
  info186: "Indeterminacy",
  info187: "Select the due date",
  info188: "Date of payment of the balance",
  info189: "Determine when the balance payment will be made",
  info190: "The hour cannot be empty",
  info191: "Please select the source name",
  info192: "Please enter quantity (box)",
  info193: "Please enter the specification and size",
  info194: "Please enter the origin name",
  info195: "Please select fishing time",
  info196: "Please enter the name of the vessel",
  info197: "Please enter ship name",
  info198: "Please enter a custom sea temperature",
  info199: "Please select the source address",
  info200: "Please enter the address",
  info201: "Please enter the number of pieces",
  info202: "Please enter the weight",
  info203: "Please select a production date",
  info204: "Please select a bidding date",
  info205: "Please select the bidding time",
  info206: "Please select the bidding start time",
  info207: "Please select the bidding end time",
  info208: "Please enter the price reduction (Yuan/ton)",
  info209: "Please select the delivery date",
  info210: "Please select a billing method",
  info211: "Please select shipping",
  info212: "Frozen performance bond required",
  info213: "Please select a bid type",
  info214: "Please enter the first scale",
  info215: "Please enter the balance ratio",
  info216: "Please select the due date",
  info217: "Please select a pricing method",
  info218: "Please select a delivery method",
  info219: "Please select a delivery period",
  info220: "Please select the latest due date",
  info221: "Above",
  info222: "The hour cannot be empty",
  info223: "The time limit for stocking cannot be less than 1 hour",
  info224: "The time limit for stocking cannot exceed 48 hours",
  info225: "This action will delete the draft. Do you want to continue?",
  info226: "Please upload pictures",
  info227: "Upload attachment size cannot exceed 20MB!",
  info228: "Upload a maximum of 30 attachments",
  info229: "Please upload the tag picture",
  info230: "Please upload brand pictures",
  info231: "Please upload a picture of the fish",
  info232: "Please upload pictures of gills",
  info233: "Please upload a picture of ice volume",
  info234: "Please upload your ID photo",
  info235:
    "The maximum price entered cannot be lower than the minimum price, please check the data carefully",
  info236: "Customization",
  info237: "Deposit is insufficient, please transfer in",
  info238: "The maximum number of rows has been exceeded",
  info239: "Supports up to 5 tiered pricing levels",
  info240: "Please enter the minimum number of boxes first",
  info241: "The price cannot be empty",
  info242: "Please enter a number. Reserve a maximum of two decimals",
  info243: "The price can not be lower than 50 yuan /kg",
  info244: "The price cannot be higher than 150 yuan /kg",
  info245: "The maximum number of boxes cannot be empty",
  info246:
    "If there is any discrepancy between the actual outbound weight and the estimated weight, the actual outbound weight shall prevail, and the difference generated shall be refunded more than made up;",
  info247:
    "In order to ensure the smooth flow of subsequent transactions, the expected weight will be multiplied by 90%, and the buyer will make up the full payment in the delivery process, please do not worry.",
  info248: "First ** yuan",
  info249: "The final payment is expected to be RMB **",
  info250: "Due date",
  info251:
    "You can find the order before the latest date of payment and click [Initiate payment] to start the payment process.",
  info252: "Enterprise main body",
  info253: "Collection card",
  info254: "Name of vessel",
  info255: "Name of the carrier",
  info256: "Product traceability certificate",
  info257: "Other photos",
  info258: "Transaction setup",
  info259: "Pricing method",
  info260: "Box number interval (small)",
  info261: "Box number interval (large)",
  info262: "Delivery by ** at the latest",
  info263: "Delivery within ** hours after transaction",
  info264: "Unit price (Yuan/kg)",
  info265: "Total amount (Yuan)",
  info266: "View the net weight of each specification",
  info267: "Agency source",
  info268: "Overseas",
  info269:
    "Please enter keywords to search, including product name, origin, etc",
  info270: "Release Source",
  info271: "District",
  info272: "All categories",
  info273: "Port of destination",
  info274: "Port of departure",
  info275: "Storage temperature",
  info276: "Consult",
  info277: "Source details",
  info278: "SIZE",
  info279: "Package",
  info280: "Packing specification",
  info281: "Total gross weight",
  info282:
    "If you want to purchase this supply, please contact the platform staff",
  info283: "Login for overseas users",
  info284: "User login portal in Chinese Mainland",
  info285: "Login Phone Number",
  info286: "Please enter content",
  info287: "Change mobile No.",
  info288: "Bind mobile No.",
  info289: "Login Email",
  info290: "Change mail box",
  info291: "Bind mailbox",
  info292: "Please enter the new phone number you want to change",
  info293: "Change mailbox",
  info294: "Current mailbox",
  info295: "Please enter your email address",
  info296: "Please enter your mobile NO.",
  info297:
    "During the certification audit, you can also modify and supplement before the certification is passed.",
  info298: "The certification is successful , you can publish the source.",
  info299: "Authentication failed, please edit and re-submit.",
  info300: "Registration Information",
  info301: "One: Basic information",
  info302: "Type of company",
  info303: "Date of establishment",
  info304: "Click to select date",
  info305: "Date of registration",
  info306: "Validity period of license",
  info307: "Registered capital",
  info308: "Tax Identification No.",
  info309: "Registration number in China",
  info310: "Business license document",
  info311: "Two: Business information",
  info312: "EU registration number",
  info313: "Other certificates",
  info314: "Bank name",
  info315: "Bank address",
  info316: "Beneficiary",
  info317: "Beneficiary’s address",
  info318: "Four: Contact information",
  info319: "Wechat ID",
  info320: "Five: Company introduction",
  info321: "Product introduction",
  info322: "Official website address",
  info323: "Other information",
  info324: "Email address",
  info325: "The registration Info is submitted successfully ",
  info326: "Please wait for review",
  info327:
    "If you wish to modify the registration information, please contact:",
  info328: "Upload up to 30 images",
  info329: "Docked",
  info330: "Submission time",
  info331: "Currently on display",
  info332: "Copy the information and put it back on the shelf",
  info333: "Edited and republished",
  info334: "Successful operation",
  info335: "Please fill in the source information",
  info336: "No packagin",
  info337: "Product photo",
  info338: "(Minimum 5 photos, maximum 50 photos)",
  info339: "Quotation mode",
  info340: "Quotation information",
  info341: "Offer",
  info342: "Import port of destination",
  info343: "Port of Departure",
  info344: "Please enter a quote",
  info345: "Publish",
  info346: "The source information is submitted successfully",
  info350:
    "The error between total net weight and total gross weight shall not exceed 10%",
  info351: "Please upload at least 5 photos of the source",
  info352: "Account Management",
  info353: "My Supply ",
  info354: "Salmon Zone Trading Instructions (Trial Operation)",
  info355:
    "Please sign the contract within 30 minutes after delisting, otherwise the delisting is invalid and the transaction fails.",
  info356: "Login via Verification Code",
  info367: "Email Login",
  info368: "To be released",
  info369: "Upload",
  info370: "Current total price",
  info371: "Total transaction price",
  info372: "Total starting bid",
  info373: "Please check the order",
  info374: "The mailbox format is incorrect",
  info375:
    "The current account is not authenticated successfully, please authenticate first ~",
  info376: "Trigger delay",
  info377: "Delisting record",
  info378: "Delisting party",
  info379: "Unpublish",
  info380: "The first and last payment does not include service fee;",
  info381:
    "The initial and final payment will change with the bidding process;",
  info382: "The first and last payment is subject to the actual settlement.",
  info383: "Pending sale",
  info384: "Opening time",
  info385: "Short to go on sale",
  info386: "Number of applicants",
  info387: "Uploading the payment voucher succeeded",
  info388: "Upload payment voucher",
  info389: "Drag the file here, or click Upload",
  info390: "Payment voucher",
  info392: "Three: Bank account information",
  info393: "Your Name",
  info394: "Completed",
  info395: "Trading Notice",
  info396: "Company Type",
  info397:
    "The current account does not have the permission to publish the source",
  info398: "Total ** bid records",
  info399: "Processed Products",
  info400: "Packages",
  info401: "U.S. dollar",
  info402: "kilogram",
  info403: "Give birth to",
  info404: "Specifications (Individual products）",
  info405: "Gross weight (kg)",
  info406: "Total net weight (kg)",
  info407: "Storage temperature",
  info408: "Subzero",
  info409: "Origin of raw materials",
  info410: "Production lot",
  info411: "Warranty period",
  info412: "Product category",
  info413: "Other characteristics",
  info414: "English name",
  info415: "Latin name",
  info416: "Proportion of protective ice coating",
  info417: "General source",
  info418: "Source of finished goods",
  info419: "(Individual product)",
  info420: "Net weight per piece",
  info421: "Gross weight (kg)",
  info422: "Calculated income",
  info423: "Total net weight (kg)",
  info424: "(Recommended to upload 5-10 photos)",
  info425: "(Can only upload pdf,excel,word files, and no more than 20M)",
  info426: "Unit price (USD /kg)",
  info427: "Total price ($)",
  info428: "Published successfully ~",
  info429: "Please enter the proportion of protective ice coats",
  info430: "Cannot be less than 0",
  info431: "Should not be greater than 10",
  info432: "Central price",
  info433: "Specification (Chinese)",
  info434: "Specification (English)",
  info435: "Unit price (USD/KG)",
  info436: "Weight (KGS)",
  info437: "The weight cannot be empty",
  info438: "Specification details",
};



// WEBPACK FOOTER //
// ./src/lang/en.js